import {
  DrawerBody,
  DrawerHeader,
  DrawerContent,
  Drawer,
  DrawerOverlay,
  Flex,
  Heading,
  Divider,
  Button,
  Text,
  DrawerFooter,
} from '@chakra-ui/react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { InvoiceFragmentGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { getInvoiceComputedStatus } from '../utils';
import { InvoiceDetailActionsMenu } from './InvoiceDetailActionsMenu';
import { Icon } from 'packages/common-frontend/components/icons';
import { truncateUuid } from 'packages/common-frontend/utils';
import { InvoiceDetailInformation } from 'packages/invoices/ui/InvoiceDetailInformation';
import { InvoiceStatusBadge } from 'packages/invoices/ui/InvoiceStatusBadge';

type InvoiceDetailSideDrawerHeaderProps = {
  invoiceId: string;
  onCloseDrawer: () => void;
};
const InvoiceDetailSideDrawerHeader = ({
  invoiceId,
  onCloseDrawer,
}: InvoiceDetailSideDrawerHeaderProps) => {
  return (
    <>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        m="24px 24px 0 0"
      >
        <Heading
          as="h3"
          fontSize="20px"
          lineHeight="28px"
          fontWeight={600}
          m="24px 24px 24px 40px"
        >
          {`Invoice ${truncateUuid(invoiceId)}`}
        </Heading>
        <Button variant="v2-ghost" onClick={onCloseDrawer}>
          <Icon icon="x" />
        </Button>
      </Flex>
      <Divider />
    </>
  );
};

type InvoiceDetailSideDrawerProps = {
  invoice: InvoiceFragmentGQLType;
  isOpen: boolean;
  onClose: () => void;
};
export const InvoiceDetailSideDrawer = ({
  invoice,
  isOpen,
  onClose,
}: InvoiceDetailSideDrawerProps) => {
  const computedStatus = getInvoiceComputedStatus({
    status: invoice.status,
    dueDate: invoice.dueDate,
    targetInvoiceDate: invoice.targetInvoiceDate ?? undefined,
  });

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="xl">
      <DrawerOverlay />
      <DrawerContent>
        <DrawerHeader padding="0">
          <InvoiceDetailSideDrawerHeader
            invoiceId={invoice.id}
            onCloseDrawer={onClose}
          />
        </DrawerHeader>

        <DrawerBody p="40px">
          <Flex alignItems="center" justifyContent="space-between" mb="40px">
            <InvoiceStatusBadge
              computedStatus={computedStatus}
              useBackgroundColors
            />
            <InvoiceDetailActionsMenu invoice={invoice} />
          </Flex>
          <InvoiceDetailInformation invoice={invoice} />
        </DrawerBody>
        <DrawerFooter>
          <Flex w="100%" justifyContent="flex-end">
            <Button
              as={RouterLink}
              to={`/invoices/${invoice.id}`}
              variant="v2-ghost"
              rightIcon={<Icon icon="chevron-right" />}
            >
              <Text mr="8px">View Invoice</Text>
            </Button>
          </Flex>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};
